import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
  withRouter,
  Redirect,
  useParams
} from "react-router-dom";
// import Banners from '../banners';
import TopSlider from '../top-slider';
import Footer from '../footer';
import Home from '../home';
import Category from '../category';
import LeftMenu from '../left-menu';
import ProductPage from '../product-page';
import CompanyProductsPage from '../company-products-page';
import SearchPage from '../search-page';
import ThankYouPage from '../thank-you-page';
import NotFoundPage from "../not-found-page";
import Header from '../header';
import { ThemeContext } from '../../elements/themes/themeContext.js'
import { AnimatePresence, motion, transform } from 'framer-motion';

import RequestInformation from '../request-information';
import ConfigurationService from "../../services/configuration-service";

import ServerApi from '../../services/server-api-service'
import '../../elements/common.css';
import '../../elements/themes/themes-style.css';


const PAGE_TRANSITION = {
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  
  }
}

function _ScrollToTop(props) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return props.children
}

const ScrollToTop = withRouter(_ScrollToTop)
class Expo extends React.Component {
  serverApi = new ServerApi();
  configurationService = new ConfigurationService();
  constructor(props) {
    super(props);
    this.state = {
      debug: false,
      isVisibleLeftMenuCategory: false,
      isVisibleRecentlyProductsModal: false,
      isVisibleHeaderMenu: false,
      isVisibleLoginModal: false,
      isVisibleRequestInfo: false,
      requestInfoCompanyData: {},
      requestInfoData: {},
      isVisibleRegisterModal: false,
      showMobileSearchBar: false,
      pageScroll: 0,
      userData: {
        username: '',
        id: null,
        phone:null, 
        // phone:"+375445215572", 
      },
      // currentCategory:0,
      // currentCategoryNesting:0,
      currentPageWidth: 0
    }
    this.getRecentlyProducts = this.getRecentlyProducts.bind(this);
    this.handleOnLogin = this.handleOnLogin.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
  }

  handleResize = (event) => {
    let width = event.target.innerWidth;
    let height = event.target.innerHeight;

    if (this.state.debug) {
      console.log('Swithced to mobile version');
    }
    this.setState({
      width: width,
      height: height,
    })
  }


  // changeCategory =({categoryId,categoryNesting})=>{

  // }

  getUserInfo() {
    let param = '';
    let urn = document.location.search.replace('?', '&');
    if (urn.includes('ui=') && urn.includes('vrf=')) {
      param = document.location.search.replace('?', '&');
      console.log(param);
    }
    this.serverApi.getUserData(param).then((response) => {
      if (response.status !== 'error') {
        this.setState((prevState) => {
          return {
            userData: {
              ...this.state.userData,
              username: response.user.username,
              id: response.user.id,
              email: response.user.email,
              gt_firstname: response.user.gt_firstname,
              phone:response.user.phone
            }
          }
        })
        // this.setState({
        //   userData: {
        //     username: response.user.username,
        //     id: response.user.id,
        //     email: response.user.email,
        //     gt_firstname: response.user.gt_firstname
        //   }
        // })
      }
    }
    )
      .catch((error) => {
        console.log(`Error with getUserInfo: ${error}`)
      })
  }


  componentWillUpdate() {
    if (this.state.version && this.state.version != document.getElementById('version').content) {
      window.location.href = window.location.href
    }
    if (this.state.debug) {
      console.log("componentWillUpdate: APP component...");
    }
    //console.log("document.body.scrollHeight: " + document.body.scrollHeight);
  }

  injectHotjar() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.text = `(function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:2592424,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    script.async = true;

    console.log(script);
    document.body.appendChild(script);
  }

  handleScroll = () => {
    this.setState((prevState) => {
      return {
        pageScroll: window.pageYOffset
      }
    })
    // this.setState({
    //     pageScroll: window.pageYOffset
    // })
  }

  getAllCountry = () => {
    this.serverApi.getAllCountry()
      .then((data) => {
        this.setState((prevState) => {
          return {
            ...this.state,
            country: data.country
          }
        })
        // this.setState({
        //   ...this.state,
        //   country: data.country
        // })
      })
      .catch((error) => {
        console.log('Error loading country list ', error);
      })
  }

  getAllEstablishmentType = () => {
    this.serverApi.getAllEstablishmentType()
      .then((data) => {
        if (this.state.debug) {
          console.log('Establishment type list: ', data);
        }

        this.setState((prevState) => {
          return {
            ...this.state,
            establishmentTypes: data.establishmentTypes,
          }
        })

        // this.setState({
        //   ...this.state,
        //   establishmentTypes: data.establishmentTypes,
        // })
      })
      .catch((error) => {
        console.log('Error loading establishment types', error);
      })
  }

  defineTheme() {
    let siteTheme = this.configurationService.defineTheme();
    let favicon = document.getElementById('favicon');
    let title = document.getElementById('title');
    if (siteTheme === 'hmi') {
      favicon.href = `${document.location.origin}/expo/expo-logo-ico.ico`;
      // favicon.href = `${document.location.origin}/expo/expo-logo-ico.ico`;
      title.content = 'Hospimedica Expo'
    }
    else {
      favicon.href = `${document.location.origin}/expo/favicon.ico`;
      title.innerText = 'Labmedica Expo'
    }
    this.setState((prevState) => {
      return {
        siteTheme: siteTheme
      }
    })
  }

  componentWillMount() {
    this.defineTheme();
    this.getVersion();

    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    })
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);

    document.addEventListener('closeAllModals', () => {
      this.closeAllModals();
    })
    document.addEventListener('openModal', (event) => this.openModal(event))
    this.getAllCountry();
    if (!this.state.language) {
      this.setState((prevState) => {
        return {
          language: this.configurationService.getCurrentLanguage(),
          languagePrefix: this.configurationService.getCurrentLanguagePrefix()
        }
      })
      // this.setState({
      //   language: this.configurationService.getCurrentLanguage()
      // })
    }

    if (this.configurationService.getCurrentLanguagePrefix() === 'en') this.injectHotjar();

    if (this.state.debug) {
      console.log("componentWillMount: APP component...");
    }

    this.getUserInfo();
    this.getRecentlyProducts();
    this.getAllEstablishmentType();


  }

  componentWillUnmount() {
    document.removeEventListener('closeAllModals', this.closeAllModals);
    document.removeEventListener('openModal', this.openModal);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  getVersion = () => {
    if (!document.location.href.includes('.onserv')) {
      this.serverApi.getVersion()
        .then((data) => {
          this.setState({
            version: data.version
          })
        })
    }
  }

  handleOnLogin() {
    this.getUserInfo();
  }

  openModal = (event) => {
    this.closeAllModals();
    if (event.detail.name === 'isVisibleRequestInfo') {

      this.setState((prevState) => {
        return {
          [event.detail.name]: event.detail.value,
          requestInfoCompanyData: event.detail.companyData,
          requestInfoData: event.detail.data
        }
      })
      // this.setState({
      //   [event.detail.name]: event.detail.value,
      //   requestInfoCompanyData:event.detail.companyData,
      //   requestInfoData:event.detail.data
      // })
    } else {
      this.setState((prevState) => {
        return {
          [event.detail.name]: event.detail.value
        }
      })
      // this.setState({
      //   [event.detail.name]: event.detail.value
      // })
    }
  }
  closeAllModals = () => {
    this.setState((prevState) => {
      return {
        isVisibleLeftMenuCategory: false,
        isVisibleHeaderMenu: false,
        isVisibleLoginModal: false,
        isVisibleRegisterModal: false,
        isVisibleRequestInfo: false,
        isVisibleRecentlyProductsModal: false,
        showMobileSearchBar: false
      }
    })
    // this.setState({
    //   isVisibleLeftMenuCategory: false,
    //   isVisibleHeaderMenu: false,
    //   isVisibleLoginModal:false,
    //   isVisibleRegisterModal:false,
    //   isVisibleRequestInfo:false,
    //   isVisibleRecentlyProductsModal:false,
    //   showMobileSearchBar: false
    // })
  }

  getRecentlyProducts() {
    this.serverApi.getRecentlyViewed()
      .then((data) => {
        this.setState((prevState) => {
          return {
            recentlyViewedProducts: data.recently_viewed
            // recentlyViewedProducts:[
            //   {
            //       "product_id": "8066",
            //       "title": "Immunoassay Analyzer",
            //       "model": "ARCHITECT i1000SR",
            //       "conditions": "1",
            //       "is_newly_created": "0",
            //       "covid_19": "0",
            //       "description": "The ARCHITECT i1000SR immunoassay analyzer has built-in flexible protocols that enhance laboratory workflow and allow reporting of results with confidence. It has a maximum throughput of up to 100 tests per hour and requires a sample volume of 10-150 μL (average 62 µL) of serum, plasma, whole blood or urine.",
            //       "anonce_description": "The ARCHITECT i1000SR immunoassay analyzer has built-in flexible protocols that enhance laboratory workflow...",
            //       "specifications": "•\tMethods: CHEMIFLEX <br />\r\n•\tMaximum Throughput: Up to 100 tests/hour<br />\r\n•\tSample Types: Serum, Plasma, Whole Blood, Urine<br />\r\n•\tSample Tubes: Height: 72-102 mm; Diameter: 9.6-16.1 mm<br />\r\n•\tSample Cup: Yes (50 µl dead volume) <br />\r\n•\tSample Capacity: 65<br />\r\n•\tSample Barcode Types: Code 39, Codabar, Interleaved 2 of 5, Code 128 <br />\r\n•\tSample Result Storage: 50,000<br />\r\n•\tSample Volume: 10-150 μL, Average: 62 µL<br />\r\n•\tAutomatic Dilution: Yes<br />\r\n•\tSample Probe Carryover: ≤0.1 parts per million<br />\r\n•\tReagent Capacity: 25 refrigerated positions<br />\r\n•\tReagent Type: 100% liquid ready-to-use<br />\r\n•\tReagent Onboard Stability: 14-30 days<br />\r\n•\tCalibration Frequency: Calibrate with new lot number, if controls are out of range or if specified otherwise within the package insert<br />\r\n•\tSample, Clot and Bubble Detection: Yes<br />\r\n•\tReagent Pressure Monitoring: Yes <br />\r\n•\tSample Interference Measurement: No<br />\r\n•\tSystem Control Center: 1 SCC, with color touchscreen monitor, keyboard and mouse<br />\r\n•\tOnboard Maintenance Records: Yes<br />\r\n•\tOnline Error Code Help: Yes<br />\r\n•\tHost Interface: Bidirectional, serial RS-232 interface, host query option available<br />\r\n•\tRemote Diagnostics: AbbottLink<br />\r\n•\tDimensions (H x W x D): 49” x 59” x 30”; 124.5 x 149.9 x 76.2 cm<br />\r\n•\tWeight: 636 lbs, 288 kg <br />\r\n•\tElectrical Requirements: AC 110-120V or 200-240V, ±10%, 50 or 60 Hz self-adjusting<br />\r\n•\tWater Requirements: Purified water to dilute buffer concentrate<br />\r\n•\tHeat Output*: 2400 BTU/hr, running mode<br />\r\n•\tSample Loading: RSH<br />\r\n<br />\r\n*Values provided represent the typical output in “Running” mode for the system processing module and sample handler. A maximum value of 389 BTU/hr was obtained for the System Control Center (SCC) using the ARCHITECT i2000SR as a representative system. Values obtained during an internal study. Data is on file with Abbott Diagnostics.<br />\r\n",
            //       "features": "",
            //       "images": [
            //           "https://img.trademed.com.axis1.net/products/8066/ARCHITECT i1000SR.jpg"
            //       ],
            //       "certificates": false,
            //       "videos": false,
            //       "documents": false,
            //       "company": {
            //           "id": "4671",
            //           "advertno": "980109196",
            //           "company_name": "Abbott Diagnostics",
            //           "company_logo_url": "https://img.trademed.com.axis1.net/members/4671/logo/Abbott Diagnostics.jpg",
            //           "company_rank": "Gold",
            //           "company_rank_id": "3"
            //       }
            //   },
            //   {
            //       "product_id": "5206",
            //       "title": "Immunoassay Analyzer",
            //       "model": "PRISMnEXT",
            //       "conditions": "1",
            //       "is_newly_created": "0",
            //       "covid_19": "0",
            //       "description": "The PRISMnEXT is a fully automated  immunoassay analyzer designed to perform Chemiluminescent Immunoassay (ChLIA) technology and provide automated processes that deliver high throughput, walk-away testing protocols. It performs batch/continuous access and STAT processing of specimens containing both large and small molecular weight analytes. It enhances process automation and cGMP compliance and offers a comprehensive menu of blood screening assays. ",
            //       "anonce_description": "The PRISMnEXT is a fully automated  immunoassay analyzer designed to perform Chemiluminescent Immunoassay...",
            //       "specifications": "•\tAssay technology: Chemiluminescent immunoassay<br />\r\n•\tSample Types: Serum, Plasma<br />\r\n•\tAssay channels: 4 or 6 (Channels are configured for specific assays during installation by an Abbott representative.)<br />\r\n•\tSample racks: 28 positions per rack<br />\r\n•\tMaximum: 10 racks<br />\r\n•\tReaction trays: 16 reaction cells per tray<br />\r\n•\tMaximum loading: 27 trays per tray loader<br />\r\n•\tSample dispense: volume 50-100 μL ± 10%<br />\r\n•\tSystem control center: VGA-compatible color monitor with keyboard<br />\r\n•\tDimensions: (HxWxD) 68” x 91.6” x 33.1”; 1.73 x 2.33 x .84 m<br />\r\n•\tWeight: 1660 lb, 753 kg<br />\r\n•\tUninterruptible power supply: Single phase 200-240 VAC ± 10%<br />\r\n",
            //       "features": "",
            //       "images": [
            //           "https://img.trademed.com.axis1.net/products/5206/PRISMnEXT.jpg"
            //       ],
            //       "certificates": false,
            //       "videos": false,
            //       "documents": false,
            //       "company": {
            //           "id": "4671",
            //           "advertno": "980109196",
            //           "company_name": "Abbott Diagnostics",
            //           "company_logo_url": "https://img.trademed.com.axis1.net/members/4671/logo/Abbott Diagnostics.jpg",
            //           "company_rank": "Gold",
            //           "company_rank_id": "3"
            //       }
            //   },
            //   {
            //       "product_id": "2504",
            //       "title": "Clinical Chemistry Analyzer",
            //       "model": "ARCHITECT c16000",
            //       "conditions": "1",
            //       "is_newly_created": "0",
            //       "covid_19": "0",
            //       "description": "The ARCHITECT c16000 clinical chemistry analyzer features a load-up capacity of 215 samples with 35 priority positions and 65 refrigerated reagent positions. It offers a maximum throughput of up to 1,800 tests per hour, and is integrated with the ARCHITECT i2000SR immunoassay analyzer for allowing laboratories to handle clinical chemistry and immunoassay testing on one platform.",
            //       "anonce_description": "The ARCHITECT c16000 clinical chemistry analyzer features a load-up capacity of 215 samples with 35 priority...",
            //       "specifications": "•\tMethods: Photometric, Potentiometric, Turbidimetric<br />\r\n•\tMaximum Throughput: Up to 1,800 tests/hour<br />\r\n•\tSample Types: Serum, Plasma, Urine, CSF<br />\r\n•\tSample Tubes: Height: 72-102 mm; Diameter: 9.6-16.1 mm <br />\r\n•\tSample Cup: Yes (50 µL dead volume)<br />\r\n•\tSample Capacity: 215<br />\r\n•\tSample Barcode Types: Code 39, Codabar, Interleaved 2 of 5, Code 128<br />\r\n•\tSample Result Storage: 50,000<br />\r\n•\tSample Volume: 1.5-35 µL, Average: 6 µL<br />\r\n•\tAutomatic Dilution: Yes<br />\r\n•\tSample Probe Carryover: \t≤0.1 parts per million<br />\r\n•\tReagent Capacity: Up to 130 refrigerated positions plus patented ISE (Na+, K+ and Cl-)<br />\r\n•\tReagent Type: >95% liquid ready-to-use<br />\r\n•\tReagent Onboard Stability: 5-65 days, Average: 40 days<br />\r\n•\tCalibration Frequency: 1-60 days, Average: 25 days<br />\r\n•\tSample, Clot and Bubble Detection: Yes<br />\r\n•\tReagent Pressure Monitoring: Yes <br />\r\n•\tSample Interference Measurement: Yes - Hemolysis, Icterus and Lipemia<br />\r\n•\tSystem Control Center: 1 SCC, with color touchscreen monitor, keyboard, and mouse<br />\r\n•\tOnboard Maintenance Records: Yes <br />\r\n•\tOnline Error Code Help: Yes<br />\r\n•\tHost Interface: Bidirectional, serial RS-232 interface, host query option available<br />\r\n•\tRemote Diagnostics: AbbottLink<br />\r\n•\tDimensions (H x W x D): 48\" x 79\" x 49\"; 121.9 x 200.6 x 124.5 cm <br />\r\n•\tWeight: 1,545 lb; 701 kg <br />\r\n•\tElectrical Requirements: AC 180-264V, 47-63 Hz, 20 amp<br />\r\n•\tWater Requirements: Deionized water ≤54 liters/hour during normal operation <br />\r\n•\tHeat Output*: 4730 BTU/hr, running mode<br />\r\n•\tSample Loading: RSH + Carousel<br />\r\n<br />\r\n*Values provided represent the typical output in “Running” mode for the system processing module and sample handler. A maximum value of 389 BTU/hr was obtained for the System Control Center (SCC) using the ARCHITECT i2000SR as a representative system. Values obtained during an internal study. Data is on file with Abbott Diagnostics.<br />\r\n",
            //       "features": "",
            //       "images": [
            //           "https://img.trademed.com.axis1.net/products/2504/c16000 c.jpg"
            //       ],
            //       "certificates": false,
            //       "videos": false,
            //       "documents": false,
            //       "company": {
            //           "id": "4671",
            //           "advertno": "980109196",
            //           "company_name": "Abbott Diagnostics",
            //           "company_logo_url": "https://img.trademed.com.axis1.net/members/4671/logo/Abbott Diagnostics.jpg",
            //           "company_rank": "Gold",
            //           "company_rank_id": "3"
            //       }
            //   }
            //]
          }
        })
        // this.setState({
        //   recentlyViewedProducts: data.recently_viewed
        // })
      })
      .catch((error) => {
        console.log(error);
      })
  }



  render() {

    let { userData, country, establishmentTypes, language, isVisibleLeftMenuCategory
      , isVisibleLoginModal, isVisibleHeaderMenu, isVisibleRecentlyProductsModal,
      isVisibleRegisterModal, showMobileSearchBar, recentlyViewedProducts, isVisibleRequestInfo,
      requestInfoCompanyData, requestInfoData, pageScroll, siteTheme, width,languagePrefix } = this.state;
    return (
      <AnimatePresence exitBeforeEnter>
        <Router basename={'/expo'} >
          <ThemeContext.Provider value={{ siteTheme: siteTheme, language: language,languagePrefix:languagePrefix }} >
            <div id={siteTheme === 'hmi' ? ('Hospimedica') : ('Labmedica')}>
              {/* <Header/> */}
              {/* <StaticHeader/> */}
              {/* <ScrollToTop> */}
              {/* <Banners /> */}
              {/* <Search/> */}
              <Header
                handleOnLogin={this.handleOnLogin}
                userData={userData}
                language={language}
                isVisibleHeaderMenu={isVisibleHeaderMenu}
                showMobileSearchBar={showMobileSearchBar}
                isVisibleLoginModal={isVisibleLoginModal}
                isVisibleRegisterModal={isVisibleRegisterModal}
                width={width}
              />
              <div >

                <Switch >

                  <Route exact path={`/`}>
                    <ScrollToTop>
                     
                        <Home
                          isVisibleHeaderMenu={isVisibleHeaderMenu}
                          userData={userData}
                          country={country}
                          establishmentTypes={establishmentTypes}
                          language={language}
                          handleOnLogin={this.handleOnLogin}
                          width={width}
                        />
                    </ScrollToTop>
                  </Route>


                  <Route path={[`/category/:id/:name+/:page`, `/category/:id/:name+/`]}>
                      <Category
                        isVisibleHeaderMenu={isVisibleHeaderMenu}
                        userData={userData}
                        country={country}
                        establishmentTypes={establishmentTypes}
                        language={language}
                        handleOnLogin={this.handleOnLogin}
                        width={width}
                      />
                  </Route>


                  <Route path={[`/company/:id/:name/products`, `/company/:id/products`]}>
                    <ScrollToTop>
                     
                        <CompanyProductsPage
                          isVisibleHeaderMenu={this.state.isVisibleHeaderMenu}
                          country={this.state.country}
                          establishmentTypes={this.state.establishmentTypes}
                          userData={this.state.userData}
                          language={language}
                          pageScroll={pageScroll}
                          handleOnLogin={this.handleOnLogin}
                          width={width}
                        />
                    </ScrollToTop>
                  </Route>

                  <Route path={`/product/:id/:name`}>
                    <ScrollToTop>
                    
                        <ProductPage
                          isVisibleHeaderMenu={isVisibleHeaderMenu}
                          getRecentlyProducts={this.getRecentlyProducts}
                          userData={userData}
                          country={country}
                          establishmentTypes={establishmentTypes}
                          language={language}
                          pageScroll={pageScroll}
                          handleOnLogin={this.handleOnLogin}
                          width={width}
                        />
                    </ScrollToTop>
                  </Route>

                  {/* <Route path={`/company/:id/:name/products`}>
            <ScrollToTop>
              <CompanyProductsPage
                isVisibleHeaderMenu={isVisibleHeaderMenu}
                country={country}
                establishmentTypes={establishmentTypes}
                userData={userData}
                language={language}
                handleOnLogin={this.handleOnLogin}
                triggerCloseModals = {this.closeAllModals}
              />

            </ScrollToTop>
          </Route> */}

                  <Route path={[
                    `/search/:categoryId/:request/:page/:option?`]}>
                  
                      <SearchPage
                        isVisibleHeaderMenu={isVisibleHeaderMenu}
                        userData={userData}
                        country={country}
                        establishmentTypes={establishmentTypes}
                        language={language}
                        handleOnLogin={this.handleOnLogin}
                        width={width}
                      />
                  </Route>
                  <Route path={'/thank_you'}>
                   
                      <ThankYouPage
                        isVisibleHeaderMenu={isVisibleHeaderMenu}
                        userData={userData}
                        country={country}
                        establishmentTypes={establishmentTypes}
                        language={language}
                        handleOnLogin={this.handleOnLogin}
                        width={width}
                      />
                  </Route>
                  <Route path={'/not_found'}>
                   
                      <NotFoundPage
                        userData={userData}
                        country={country}
                        language={language}
                        width={width}
                      />
                  </Route>
                  {/* for next page */}
                  {/* <Route path={`/company/:id/videos/`}><CompanyProductsPage userData={this.state.userData} /></Route>
              <Route path={`/company/:id/news/`}><CompanyProductsPage userData={this.state.userData} /></Route>
              <Route path={`/company/:id/whitepappers/`}><CompanyProductsPage userData={this.state.userData} /></Route> */}
                  {/* undefined route */}
                  <Redirect to="/not_found" />
                </Switch>
              </div>
              {/* <SuppliersBar/> */}
              <Footer language={language} />
              <LeftMenu
                isVisibleLeftMenuCategory={isVisibleLeftMenuCategory}
                isVisibleRecentlyProductsModal={isVisibleRecentlyProductsModal}
                userData={userData}
                country={country}
                establishmentTypes={establishmentTypes}
                language={language}
                recentlyViewedProducts={recentlyViewedProducts}
                handleOnLogin={this.handleOnLogin}
              />
              {/* <RequestInformation
          quickInquiry ={true}
          productData={requestInfoData}
          companyData={requestInfoCompanyData}
          userData={userData}
          modalIsVisible={isVisibleRequestInfo}
          сhangeIsVisible={this.closeAllModals}
          country={country}
          establishmentTypes={establishmentTypes}
          language={language}
          handleOnLogin={this.handleOnLogin}
        /> */}
              {/* </ScrollToTop> */}
            </div>
          </ThemeContext.Provider>
        </Router >
      </AnimatePresence>
    )
  }
}
export default Expo;
